export default __webpack_public_path__ + "static/media/start.f728b3f2.md";